'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Tag.scss");

var Tag = function (_React$Component) {
    (0, _inherits3.default)(Tag, _React$Component);

    function Tag() {
        (0, _classCallCheck3.default)(this, Tag);
        return (0, _possibleConstructorReturn3.default)(this, (Tag.__proto__ || (0, _getPrototypeOf2.default)(Tag)).apply(this, arguments));
    }

    (0, _createClass3.default)(Tag, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);


            className = (0, _classnames2.default)('tag-container', className);

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className }, otherProps),
                children
            );
        }
    }]);
    return Tag;
}(_react2.default.Component);

Tag.PropTypes = {
    className: _react2.default.PropTypes.string
};
exports.default = Tag;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdGFnL1RhZy5qc3giXSwibmFtZXMiOlsicmVxdWlyZSIsIlRhZyIsInByb3BzIiwiY2xhc3NOYW1lIiwiY2hpbGRyZW4iLCJvdGhlclByb3BzIiwiUmVhY3QiLCJDb21wb25lbnQiLCJQcm9wVHlwZXMiLCJzdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7QUFFQUEsUUFBUSxZQUFSOztJQUVxQkMsRzs7Ozs7Ozs7OztpQ0FLUjtBQUFBLHlCQUNzQyxLQUFLQyxLQUQzQztBQUFBLGdCQUNBQyxTQURBLFVBQ0FBLFNBREE7QUFBQSxnQkFDV0MsUUFEWCxVQUNXQSxRQURYO0FBQUEsZ0JBQ3dCQyxVQUR4Qjs7O0FBR0xGLHdCQUFZLDBCQUFXLGVBQVgsRUFBNEJBLFNBQTVCLENBQVo7O0FBRUEsbUJBQ0k7QUFBQTtBQUFBLHlDQUFLLFdBQVdBLFNBQWhCLElBQStCRSxVQUEvQjtBQUNLRDtBQURMLGFBREo7QUFLSDs7O0VBZjRCRSxnQkFBTUMsUzs7QUFBbEJOLEcsQ0FDVk8sUyxHQUFZO0FBQ2ZMLGVBQVdHLGdCQUFNRSxTQUFOLENBQWdCQztBQURaLEM7a0JBREZSLEciLCJmaWxlIjoiVGFnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjbGFzc05hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuXG5yZXF1aXJlKFwiLi9UYWcuc2Nzc1wiKTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVGFnIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgICBzdGF0aWMgUHJvcFR5cGVzID0ge1xuICAgICAgICBjbGFzc05hbWU6IFJlYWN0LlByb3BUeXBlcy5zdHJpbmcsXG4gICAgfTtcblxuICAgIHJlbmRlcigpIHtcbiAgICAgICAgbGV0IHtjbGFzc05hbWUsIGNoaWxkcmVuLCAuLi5vdGhlclByb3BzfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgY2xhc3NOYW1lID0gY2xhc3NOYW1lcygndGFnLWNvbnRhaW5lcicsIGNsYXNzTmFtZSk7XG5cbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPXtjbGFzc05hbWV9IHsuLi5vdGhlclByb3BzfT5cbiAgICAgICAgICAgICAgICB7Y2hpbGRyZW59XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgKTtcbiAgICB9XG59XG5cbiJdfQ==